
















    import { Component, Vue, Watch } from 'vue-property-decorator';
    import { mapState } from 'vuex';
    import { StoreState } from '../../store';
    import SidebarRow from './sidebar/SidebarRow.vue';  
    import { truncate } from 'fs';

    export declare interface HellospokeAccount {
        id: string,
        name: string,
        realm: string,
        tree: string[]
    }

    declare interface SidebarData {
        user_kazoo_id: string;
        search_term: string;
        selected_id?: string;
        search_results: HellospokeAccount[];
    }

    @Component({
        components: {
            SidebarRow
        },
        computed: {
            ...mapState({
                'adminHellospokeAccounts': (state: StoreState) => state.account.admin_hellospoke_accounts,
                'selectedAccount': (state: StoreState) => state.dashboard.admin.selectedAccount,
            })
        }
    })
    export default class Sidebar extends Vue {
        data() {
            return {
                user_kazoo_id: "0",
                search_term: "",
                selected_id: null,
                search_results: [],
                accounts: [],
                input_search:false
            }
        }

        public adminHellospokeAccounts!: Object[];
        public selectedAccount!: string;
        public accounts!: any[];
        

        //This gives the accounts structured as a tree (i.e. children acocunts
        //are found in their parent's children property) rather than an array
        // get accounts() {
        //     return this.genAccountTree(this.adminHellospokeAccounts);
        // }

        @Watch('adminHellospokeAccounts')
        onAccountsFound() {
            this.accounts = this.genAccountTree(this.adminHellospokeAccounts);
            if(this.accounts.length>0){
                var id=this.accounts[0].id;
                var name=this.accounts[0].name;
                 this.$store.commit('SET_SELECTED_ADMIN_NAME',name);
                 // this.$emit('idSelected',id)
               this.$emit('idSelected', {id:id,name:name});
                this.$data.selected_id =id;
                    this.$store.commit('SET_SELECTED_ADMIN_ID', {
                        selectedAccount:{id:id,name:name}
                    });
            }
          
        }
        search_inputclick()
        {
            var x = document.getElementById("input_searchiconadmin");
            x.style.display = "none";
        }

        search_inputblur()
        {
            var x = document.getElementById("input_searchiconadmin");
            if(this.$data.search_term.length!=0){
            x.style.display = "none";
            }
            else{
            x.style.display = "inline";
            }
        }
            
        focusInput() 
        { 
                document.getElementById("input_search").focus(); 
                var x = document.getElementById("input_searchiconadmin");
                x.style.display = "none";
        } 

        @Watch('accounts')
        onAccountsLoaded() {
            this.search();
           // alert(this.$data.search_results.length )
        }
        search_input(){
            this.$data.input_search=true;
        }
        search() {
            if(this.$data.search_term === "") {
                this.$data.search_results = this.accounts;
            }
            else {
                //This cloning is happening because all the children are being
                //"removed" below (The children arrays are being cleared for each account,
                //and those children are being moved to the top level. In other words, we are making
                //a flat hierarchy) and we want to keep the original dataset with the
                //original sets of children.

                //Chidren are being "removed" because the search is just looking for
                //an account name containing the search term, which can grab accounts from
                //various generations from various parents. Keeping track of the various
                //lineages with parents and children that may or may not be filtered out by the
                //search term would make the code much more complex,
                const accountsClone = JSON.parse(JSON.stringify(this.accounts));
                this.$data.search_results = this.recursiveSearch(accountsClone, this.$data.search_term);
                for(const search_result of this.$data.search_results) {
                    search_result.children = [];
                }
            }
        }

        //This function starts at the highest level of the account hierarchy
        //and works it's way down to retrieve each accounts descendants looking for
        //accounts with the search term
        recursiveSearch(accounts: any, search_term: string): any {
            let rv = [];
            const len = accounts.length;
            for(const account of accounts) {
                if(account.name.toLowerCase().includes(search_term.toLowerCase())) {
                    rv.push((account as never));
                }
                if(account.children.length > 0) {
                    rv = rv.concat(this.recursiveSearch(account.children, search_term));
                }
            }
            return rv;
        }

       // @Watch('selectedAccount')
        changeId(data) {
            this.$store.commit('SET_ADMIN_LOADER',true)
            this.$data.selected_id =data.id;
            this.$store.commit('SET_SELECTED_ADMIN_ID', {
				selectedAccount: data.id
            });
              this.$store.commit('SET_SELECTED_ADMIN_NAME',data.name);
              this.$emit('idSelected', {id:data.id,name:data.name})
        }

        // I don't *think* that this is needed anywhere else in the application. I actually was considering
        // putting this in the store until I didn't see it anywhere else. I have been trying to only add things
        // to the store if it's included in multiple parts of the application, and otherwise keep things local
        // or use props. I was also thinking about copy/pasting this into the accounts computed property as
        // currently accounts is just the return value of the function but decided to do this so that it would
        // be a bit more descriptive as to what is going on.
        // Would be happy to move to the store or into the computed property if that would be better.
        genAccountTree(data: any) {
            let rv = [];
            const accountIds = (data || []).map((account: any) => account.id);
            for(const account of data) {
                rv.push(
                    ({
                        id: account.id,
                        name: account.name,
                        children: [],
                        // The parent of an account is the last element of it's tree property.
                        // If the parent is the user's account number, we can assume that's the top
                        // level, as we do not need to worry about the user's parent account (Section 3.4).
                        parent: account.tree[account.tree.length - 1] === this.$data.user_kazoo_id ? null : account.tree[account.tree.length - 1]
                    } as never)
                );
            }
            // If elements have a parent, add them as a child to that parent
            for(const account of rv) {
                if((account as any).parent) {
                    for(const parent of rv) {
                        if((parent as any).id === (account as any).parent) {
                            (parent as any).children.push((account as never));
                        }
                    }
                }
                else {
                    (account as any).parent = null;
                }
            }
            // Had to modify this because our test account is not the Voitress account
            rv = rv.filter((element) => {
                return !accountIds.includes((element as any).parent);
            });
            return rv;
        }
    }
